<template>
  <div
    class="app-dialer-keypad"
    :class="{ [`is-${size}`]: true }"
  >
    <input
      class="keypad-input"
      :value="dial"
      disabled
    >

    <div class="keypad-keys">
      <base-icon-button
        v-for="key of KEYS"
        :key="key"
        :content="key"
        :is-disabled="isDisabled"
        :size="size"
        color="primary"
        @click="$emit('key-click', key)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { BaseIconButton } from '@/modules/agent-picker';
import { SIZE_PROP } from '../../constants';

export default defineComponent({
  name: 'AppDialerKeypad',
  components: {
    BaseIconButton,
  },
  props: {
    dial: {
      type: String,
      default: '',
    },
    size: SIZE_PROP,
    isDisabled: Boolean,
  },
  emits: ['key-click'],
  data() {
    return {
      KEYS: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
    };
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;
@import '../../styles';

.app-dialer-keypad {
  --keys-row-gap: 0.5rem;
  --keys-column-gap: 1rem;
  --keypad-input-font-size: var(--fs-1);
  --keypad-input-width: 8rem;
  --keypad-margin-top: 1rem;

  display: inline-flex;
  flex-direction: column;

  &.is-mobile {
    --keys-row-gap: 1rem;
    --keys-column-gap: 1.75rem;
    --keypad-input-font-size: 1.75rem;
    --keypad-input-width: 14rem;
    --keypad-margin-top: 1.5rem;
  }

  .keypad-input {
    @include basic-input();

    width: var(--keypad-input-width);
    font-size: var(--keypad-input-font-size);
    line-height: 1.5;

    color: var(--or-c-on-background);
    text-align: center;
  }

  .keypad-keys {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
    column-gap: var(--keys-column-gap);
    row-gap: var(--keys-row-gap);
    margin-top: var(--keypad-margin-top);
  }
}
</style>
